import { useContext, useMemo } from 'react';
import { ENVIRONMENT_CODES } from '../../../constants';
import { environmentContext } from '../environmentContext';
export const useEnvironment = () => {
  const {
    environment = ENVIRONMENT_CODES.LIVE,
    tenant
  } = useContext(environmentContext);
  return useMemo(() => ({
    environment,
    tenant
  }), [environment, tenant]);
};
//# sourceMappingURL=useEnvironment.js.map